module.exports = __webpack_public_path__ + "img/icon-2-19c42d4f.svg";